import React from "react";

import {
  CancelRounded,
  CheckCircleRounded,
  DeleteSweepRounded,
  InfoRounded,
  WarningRounded,
} from "@mui/icons-material";
import { Box, CircularProgress, DialogContent } from "@mui/material";

import MainText from "../MainText";
import { ModalTransition } from "../ModalTransition";

import { ModalActivityType } from "../../types/common";
import { WideDialog } from "../MainModalSimple/styles";

export default function ModalActivity({ message, type, onClose }: ModalActivityType) {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 200);
  };

  return (
    <WideDialog
      fullWidth={false}
      open={open}
      onClose={handleClose}
      TransitionComponent={ModalTransition}
    >
      <DialogContent>
        <Box
          display={"flex"}
          justifyContent={"center"}
          flexDirection={"column"}
          alignItems={"center"}
          gap={2}
          p={2}
          sx={{ color: "black" }}
        >
          {type === "loading" ? (
            <CircularProgress color="inherit" />
          ) : type === "delete" ? (
            <Box sx={{ fontSize: 50, lineHeight: 0 }}>
              <DeleteSweepRounded fontSize="inherit" color="inherit" />
            </Box>
          ) : type === "error" ? (
            <Box sx={{ color: "red", fontSize: 50, lineHeight: 0 }}>
              <CancelRounded fontSize="inherit" color="inherit" />
            </Box>
          ) : type === "info" ? (
            <Box sx={{ color: "royalblue", fontSize: 50, lineHeight: 0 }}>
              <InfoRounded fontSize="inherit" color="inherit" />
            </Box>
          ) : type === "success" ? (
            <Box sx={{ color: "green", fontSize: 50, lineHeight: 0 }}>
              <CheckCircleRounded fontSize="inherit" color="inherit" />
            </Box>
          ) : type === "warning" ? (
            <Box sx={{ color: "orange", fontSize: 50, lineHeight: 0 }}>
              <WarningRounded fontSize="inherit" color="inherit" />
            </Box>
          ) : null}

          <MainText center>{message}</MainText>
        </Box>
      </DialogContent>
    </WideDialog>
  );
}
